import Oidc from "oidc-client";
//import config from '../../config';

var mgr = new Oidc.UserManager({
	authority: config.VUE_APP_AUTH,
	client_id: "downloadingweb",
	redirect_uri: config.VUE_APP_BASE_URL + "/callback",
	automaticSilentRenew: true,
	silent_redirect_uri: config.VUE_APP_BASE_URL + "/static/silent-renew.html",
	accessTokenExpiringNotificationTime: 5,
	response_type: "code",
	max_age: 28800,
	revokeAccessTokenOnSignout: true,
	scope:
		"openid profile userInfo api_downloads.full_access notifications_api.full_access",
	userStore: new Oidc.WebStorageStateStore({ store: window.localStorage }),
});
mgr.events.addAccessTokenExpired(function() {
	mgr.signinRedirect();
});
mgr.events.addSilentRenewError(function() {
	mgr.signoutRedirect();
});
/**/
export default mgr;
